import {animate, style, transition, trigger} from '@angular/animations';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';

export const appearHeight = trigger(
  'appearHeight', [
    transition(':enter', [
      style({ maxHeight: 0, opacity: 0 }),
      animate('.2s ease-out', style({ maxHeight: '300px', opacity: 1 }))
    ]),
    transition(':leave', [
      style({ maxHeight: '300px', opacity: 1 }),
      animate('.2s ease-out', style({ maxHeight: 0, opacity: 0 }))
    ])
  ]
);

export const appearWidth = trigger(
  'appearWidth', [
    transition(':enter', [
      style({ maxWidth: 0, minWidth: 0, opacity: 0 }),
      animate('.2s ease-out', style({ maxWidth: '221px', minWidth: '50px', opacity: 1 }))
    ]),
    transition(':leave', [
      style({ maxWidth: '221px', minWidth: '50px', opacity: 1 }),
      animate('.2s ease-out', style({ maxWidth: 0, minWidth: 0, opacity: 0 }))
    ])
  ]
);
